// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/frontend/stylesheets/display_results_controls.sass
// module id = 202
// module chunks = 0